export const LISTING_EDIT_TITLE_FIELD_NAME = 'listing_title'

export const LISTING_EDIT_TITLE_FIELD_MAX_LENGTH = 255

export const LISTING_EDIT_TITLE_FIELD_MIN_ROWS = 2

export const QA_NAME_LISTING_EDIT_TITLE_MODAL = 'listingEditTitleModal'

export const QA_NAME_LISTING_EDIT_TITLE_FIELD = 'listingEditTitleField'
